import apiService from '../Api'
import {
  IStudyCreditFileRaw,
  IStudyCreditNoteRaw,
  IStudyCreditOptionRaw,
  IStudyCreditPageParams,
  IStudyCreditPageRaw,
  IStudyCreditRequestDetailRaw,
  IStudyCreditStatusUpdateRaw,
  StudyCreditCourseFormat,
  StudyCreditStatus
} from './types'

export class StudyCreditRequestService {
  async getConsultants(): Promise<IStudyCreditOptionRaw[]> {
    return apiService.get('/study-credit-requests/consultants').then((response) => response.data)
  }

  async getCourses(format: StudyCreditCourseFormat): Promise<IStudyCreditOptionRaw[]> {
    return apiService.get('/study-credit-requests/courses', { params: { format } }).then((response) => response.data)
  }

  async submit(data: FormData): Promise<{ success: boolean; id: number }> {
    return apiService.post('/study-credit-requests', data).then((response) => response.data)
  }

  // One page of a single kanban column (status), with the total for its "Carregar mais".
  async list(params: IStudyCreditPageParams): Promise<IStudyCreditPageRaw> {
    return apiService.get('/study-credit-requests', { params }).then((response) => response.data)
  }

  async get(id: number): Promise<IStudyCreditRequestDetailRaw> {
    return apiService.get(`/study-credit-requests/${id}`).then((response) => response.data)
  }

  async updateStatus(id: number, status: StudyCreditStatus, note?: string): Promise<IStudyCreditStatusUpdateRaw> {
    return apiService.put(`/study-credit-requests/${id}/status`, { status, note }).then((response) => response.data)
  }

  async addNote(id: number, note: string): Promise<IStudyCreditNoteRaw> {
    return apiService.post(`/study-credit-requests/${id}/notes`, { note }).then((response) => response.data)
  }

  // Attach documents to an existing study (school records or works) added manually
  // on the kanban when the applicant forgot to submit them.
  async uploadStudyFiles(
    id: number,
    studyId: number,
    type: 'school_record' | 'work',
    files: File[]
  ): Promise<IStudyCreditFileRaw[]> {
    const data = new FormData()
    data.append('type', type)
    files.forEach((file) => data.append('files[]', file))
    return apiService
      .post(`/study-credit-requests/${id}/studies/${studyId}/files`, data)
      .then((response) => response.data)
  }

  async uploadResultFiles(id: number, files: File[]): Promise<IStudyCreditFileRaw[]> {
    const data = new FormData()
    files.forEach((file) => data.append('files[]', file))
    return apiService.post(`/study-credit-requests/${id}/result-files`, data).then((response) => response.data)
  }

  async deleteResultFile(id: number, fileId: number): Promise<void> {
    return apiService.delete(`/study-credit-requests/${id}/result-files/${fileId}`)
  }

  async remove(id: number): Promise<void> {
    return apiService.delete(`/study-credit-requests/${id}`)
  }
}
